module.exports = ".updateModal .closeButton {\n  padding-top: 10px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/account-update/account-update.component.css
// module id = ./src/app/accounts/account-update/account-update.component.css
// module chunks = main